import type { BuildDerived } from '@/types';
import { classifyKE, type KEClassification } from '@/lib/calculations';
import { Card } from '@/components/ui/Card';

interface MetricsCardsProps {
  derived: BuildDerived;
}

const keColor: Record<KEClassification['level'], string> = {
  insufficient: 'text-rose-400',
  small: 'text-emerald-400',
  large: 'text-emerald-400',
  heavy: 'text-emerald-300',
};

export function MetricsCards({ derived }: MetricsCardsProps) {
  const keClass = classifyKE(derived.ke);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Metric
        label="Total Weight"
        value={derived.weight.toFixed(0)}
        unit="gr"
        sublabel="Hunting target: 380–500 gr"
        sublabelClass="text-zinc-500"
      />
      <Metric
        label="Kinetic Energy"
        value={derived.ke.toFixed(1)}
        unit="ft·lb"
        sublabel={keClass.label}
        sublabelClass={keColor[keClass.level]}
      />
      <Metric
        label="Momentum"
        value={derived.momentum.toFixed(3)}
        unit="slug·ft/s"
        sublabel="Penetration index"
        sublabelClass="text-zinc-500"
      />
    </div>
  );
}

interface MetricProps {
  label: string;
  value: string;
  unit: string;
  sublabel: string;
  sublabelClass: string;
}

function Metric({ label, value, unit, sublabel, sublabelClass }: MetricProps) {
  return (
    <Card padding="lg">
      <div className="text-[10px] font-mono uppercase tracking-wider text-zinc-500">{label}</div>
      <div className="font-mono text-3xl font-bold mt-1 tabular-nums">
        {value}
        <span className="text-base text-zinc-500 ml-1">{unit}</span>
      </div>
      <div className={`text-[11px] mt-1 ${sublabelClass}`}>{sublabel}</div>
    </Card>
  );
}
